import { t } from 'i18next'

export const getStartNode = (editor: Editor): Element => {
  const rng = editor.selection.getRng()
  let node = rng.startContainer
  if (node.nodeType === Node.TEXT_NODE && node.parentElement) {
    node = node.parentElement
  }
  if (node instanceof Element) {
    return node
  }
  return editor.selection.getNode()
}

type ValidationConfig = {
  maxIntegers: number
  maxDecimals: number
  min: number
  max: number
}

export const validateNumericInput = (
  raw: string,
  config: ValidationConfig,
): number | null => {
  const { maxIntegers, maxDecimals, min, max } = config
  const pattern = new RegExp(
    `^\\d{1,${maxIntegers}}(\\.\\d{1,${maxDecimals}})?$`,
  )

  if (!pattern.test(raw)) return null

  const value = parseFloat(raw)
  if (value < min || value > max) return null

  return value
}

type CustomInputDialogConfig = {
  editor: Editor
  translationKey: string
  inputName: string
  placeholder: string
  initialValue: string
  validation: ValidationConfig
  onValidSubmit: (value: number) => void
}

export const openCustomInputDialog = ({
  editor,
  translationKey,
  inputName,
  placeholder,
  initialValue,
  validation,
  onValidSubmit,
}: CustomInputDialogConfig) => {
  const key = `editor.tinyMCE.${translationKey}`

  editor.windowManager.open({
    title: t(`${key}.modalTitle`),
    initialData: {
      [inputName]: initialValue,
    },
    body: {
      type: 'panel',
      items: [
        {
          type: 'input',
          name: inputName,
          label: t(`${key}.modalLabel`),
          placeholder,
        },
      ],
    },
    buttons: [
      {
        type: 'cancel',
        name: 'cancel',
        text: t(`${key}.cancelButton`),
      },
      {
        type: 'submit',
        name: 'submit',
        text: t(`${key}.applyButton`),
        primary: true,
      },
    ],
    onSubmit: (api: {
      getData: () => Record<string, string>
      close: () => void
    }) => {
      const data = api.getData()
      const raw = data[inputName].trim()
      const value = validateNumericInput(raw, validation)

      if (value === null) {
        editor.windowManager.alert(t(`${key}.invalidValue`))
        return
      }

      onValidSubmit(value)
      api.close()
    },
  })
}
